import Netflix from "../../Assets/NetflixLogo.svg";
import Reddit from "../../Assets/RedditLogo.svg";
import Amazon from "../../Assets/AmazonLogo.svg";
import Discord from "../../Assets/DiscordLogo.svg";
import Spotify from "../../Assets/SpotifyLogo.svg";

const Logos = [Netflix, Reddit, Amazon, Discord, Spotify];
export default Logos;
